import React, { useEffect, useState } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { IRoute, routes } from './routes';
import './assets/sass/App.scss';
import './assets/sass/styles.scss';
import { store } from "./redux/store";
import i18n from './i18n.js';
import { StateLoader } from './redux/StateLoader';
import { ConfigProvider } from 'antd';
import enUS from './locales/enUs';
import trTR from './locales/trTR';
import "primereact/resources/themes/lara-light-indigo/theme.css";  // tema
import "primereact/resources/primereact.min.css";                  // temel css
import "primeicons/primeicons.css";                               // ikonlar
import LoadingSpinner from './LoadingSpinner';

const App: React.FC = () => {
    const user = store.getState().user;
    const [route, setRoute] = useState<string>(undefined);
    const [locale, setLocale] = useState(enUS);
    const [loading, setLoading] = useState(true);  // Loading state'ini ekledik
    const history = useHistory();

    useEffect(() => {
        if (i18n.language === 'tr') {
            setLocale(trTR); 
        } else {
            setLocale(enUS);
        }
    }, [i18n.language]);

    useEffect(() => {
        const store = new StateLoader();
        i18n.changeLanguage(store.getLanguage() ?? "tr");
        let layout = "/" + window.location.pathname.split('/')[1];

        if (haveUser()) {
            if (pathIsExist()) {
                if (layout === "/") {
                    setRoute('/admin/dashboard');
                } else {
                    setRoute(window.location.pathname);
                }
            } else {
                setRoute('/admin/dashboard');
            }
        } else {
            if(layout === "/public") {
                setRoute(window.location.pathname);
            } else {
                setRoute('/public/sign-in');
            }
        }
    }, []);

    const pathIsExist = () => {
        let result = false;
        let splittedURL = window.location.pathname.split('/');
        let currentLayout = "/" + splittedURL[1];
        let currentPath = "/" + splittedURL[2];
        let selectedRoute = [];
        if (currentLayout.length < 1 || currentLayout === '/') {
            return true;
        }
        routes.forEach(route => {
            if (currentLayout.includes(route.path)) {
                selectedRoute = route.children;
            }
        });
        if (selectedRoute.length > 0) {
            selectedRoute.forEach((item: IRoute) => {
                if (item.path.includes(currentPath)) {
                    result = true;
                }
            });
        } else {
            result = false;
        }

        return result;
    }

    const haveUser = () => {
        return Object.keys(user).length > 0;
    }

    useEffect(() => {
        if (route) {
            setLoading(true);  // Loading'i başlat
            history.push(route);
        }
    }, [route, history]);

    useEffect(() => {
        // Sayfa geçişi dinlendiğinde loading'i kapat
        const unlisten = history.listen(() => {
            setLoading(true);  // Geçiş başladığında loading'i göster
            setTimeout(() => setLoading(false), 1000);  // 1 saniye sonra loading'i kapat
        });

        return () => {
            unlisten();
        };
    }, [history]);

    
    return (
        <ConfigProvider locale={locale}>
            <div className='App'>
                {loading && <LoadingSpinner />}
                {routes.map((route, i) => (
                    <Route key={i} path={route.path} component={route.component} />
                ))}
                {route && <Redirect exact to={route} />}
            </div>
        </ConfigProvider>
    );
};

export default App;
